import React from 'react';
import hourglassIcon from '../../../../../assets/image/hourglass.svg';

interface PendingHourGlassProps {
  statusText?: string;
  icon?: string;
}

const PendingHourGlass: React.FC<PendingHourGlassProps> = ({
  statusText = 'درخواست در حال بررسی',
  icon = hourglassIcon,
}) => {
  return (
    <div className="p-10 space-y-2 bg-gray-100 rounded-lg">
      <div className="flex flex-col items-center justify-center gap-[1rem] rounded-lg">
        <img src={icon} className="w-10" alt="pending status" />
        <span className="text-gray-800 text-md">{statusText}</span>
      </div>
    </div>
  );
};

export default PendingHourGlass;
